"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getProviders = void 0;
var firestore_1 = require("firebase/firestore");
var firebase_1 = require("../../../../app/firebase");
var platform_1 = require("../../../constants/platform");
var firebase_collections_1 = require("../../../constants/firebase_collections");
function getProviders() {
    return __awaiter(this, void 0, void 0, function () {
        var providersCollectionRef, eligibleProvidersQuery, querySnapshot, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    providersCollectionRef = (0, firestore_1.collection)(firebase_1.firestore, firebase_collections_1.FIREBASE_COLLECTIONS.PROVIDERS);
                    eligibleProvidersQuery = (0, firestore_1.query)(providersCollectionRef, (0, firestore_1.and)((0, firestore_1.where)("active", "==", true), (0, firestore_1.or)((0, firestore_1.where)("process_airtime", "==", true), (0, firestore_1.where)("product_loans", "==", true), (0, firestore_1.where)("allow_loans", "==", true))));
                    return [4 /*yield*/, (0, firestore_1.getDocs)((0, firestore_1.query)(eligibleProvidersQuery, (0, firestore_1.where)("country", "==", platform_1.PLATFORM_COUNTRY)))];
                case 1:
                    querySnapshot = _a.sent();
                    return [2 /*return*/, { success: true, message: "Succesfully Returned Providers", content: querySnapshot }];
                case 2:
                    error_1 = _a.sent();
                    return [2 /*return*/, { success: false, message: "An error occurred", content: null }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
exports.getProviders = getProviders;
